import { render, staticRenderFns } from "./confirm-borrow.vue?vue&type=template&id=0b7a4400&scoped=true"
import script from "./confirm-borrow.vue?vue&type=script&lang=js"
export * from "./confirm-borrow.vue?vue&type=script&lang=js"
import style0 from "./confirm-borrow.vue?vue&type=style&index=0&id=0b7a4400&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7a4400",
  null
  
)

export default component.exports